import { render, staticRenderFns } from "./WeekPlanAdd.vue?vue&type=template&id=400b45fe&scoped=true&"
import script from "./WeekPlanAdd.vue?vue&type=script&lang=ts&"
export * from "./WeekPlanAdd.vue?vue&type=script&lang=ts&"
import style0 from "./WeekPlanAdd.vue?vue&type=style&index=0&id=400b45fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400b45fe",
  null
  
)

export default component.exports